import { PostJobStep } from '../../../../../store/workspace/types';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import { defaultExamTranslateLanguage, examTranslateLanguagesList } from '../../../../../configs';
import { ListItem } from '../../../../../store/general/types';
import DropDown from '../../../../../components/DropDown';
import Chips from '../../../../../components/Chips';
import { TrashIcon } from '../../../../../assets/icons';
import Toggle from '../../../../../components/Toggle';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import { Dispatch, SetStateAction } from 'react';
import styles from './style.module.scss';

interface Props {
    skipCodingExam: boolean;
    multipleChoiceExam: boolean;
    multipleChoiceCodingExam: boolean;
    multipleChoiceExamSkills: string[];
    translateLanguages: ListItem[];
    translateExam: boolean;
    setTranslateExam: Dispatch<SetStateAction<boolean>>;
    setStep: (step: PostJobStep) => void;
    multipleChoiceCodingExamLanguages: string[];
    updateSkills: (v: string, i: number) => void;
    setMultipleChoiceExam: Dispatch<SetStateAction<boolean>>;
    setMultipleChoiceCodingExam: Dispatch<SetStateAction<boolean>>;
    setMultipleChoiceExamSkills: Dispatch<SetStateAction<string[]>>;
    updateMultipleChoiceCodingLanguages: (v: string, i: number) => void;
    setMultipleChoiceCodingExamLanguages: Dispatch<SetStateAction<string[]>>;
    updateTranslateLanguages: (item: ListItem, action: 'Add' | 'Remove') => void;
};

export default function MultipleChoiceExamDetail(props: Props) {
    const {
        skipCodingExam,
        multipleChoiceExam,
        multipleChoiceExamSkills,
        multipleChoiceCodingExam,
        multipleChoiceCodingExamLanguages,
        translateLanguages,
        setStep,
        updateSkills,
        setMultipleChoiceExam,
        setMultipleChoiceExamSkills,
        setMultipleChoiceCodingExam,
        updateMultipleChoiceCodingLanguages,
        setMultipleChoiceCodingExamLanguages,
        translateExam,
        setTranslateExam,
        updateTranslateLanguages,
    } = props;

    return (
        <MotionWrapper className={styles.container}>
            <span className={styles.title}>Post new job - Multiple choice exam</span>
            <div className={styles.activate}>
                <span className={styles.activate_title}>
                    Generate multiple choice exam
                </span>
                <Toggle
                    toggled={multipleChoiceExam}
                    setToggle={() => setMultipleChoiceExam(prev => !prev)}
                />
            </div>
            {multipleChoiceExam && !skipCodingExam && <div className={styles.multiChoiceCodingExam}>
                <div className={styles.activate}>
                    <span className={styles.activate_title}>
                        Would you like the multiple choice exam to have coding questions?
                    </span>
                    <Toggle
                        toggled={multipleChoiceCodingExam}
                        setToggle={() => setMultipleChoiceCodingExam(prev => !prev)}
                    />
                </div>
                {multipleChoiceCodingExam && <div className={styles.multiChoiceCodingExam_langs}>
                    <span className={styles.title}>
                        Languages you would like the <b>multiple choice exam</b> to cover for coding questions:
                    </span>
                    {multipleChoiceCodingExamLanguages.map((lang, indx) =>
                        <div
                            key={indx}
                            className={styles.multiChoiceCodingExam_langs_row}
                        >
                            <Input
                                type='text'
                                value={lang}
                                placeholder='e.g., Python'
                                wrapperClassName={styles.multiChoiceCodingExam_langs_row_input}
                                onChange={(val: string) => updateMultipleChoiceCodingLanguages(val, indx)}
                            />
                            <TrashIcon
                                onClick={() => setMultipleChoiceCodingExamLanguages((prev) => prev.filter((_, i) => i !== indx))}
                            />
                        </div>
                    )}
                    <Button
                        text='+ Add another'
                        type='Outline-Primary'
                        className={styles.add_btn}
                        disabled={multipleChoiceCodingExamLanguages.length > 9}
                        onClick={() => setMultipleChoiceCodingExamLanguages(prev => [...prev, ''])}
                    />
                </div>}
            </div>}
            {multipleChoiceExam && <div className={styles.skills}>
                <span className={styles.skills_title}>
                    Skills you would like the multiple choice exam to cover in greater details:
                </span>
                {multipleChoiceExamSkills.map((skill, indx) =>
                    <div
                        key={indx}
                        className={styles.skills_row}
                    >
                        <Input
                            type='text'
                            value={skill}
                            placeholder='e.g., Excel'
                            wrapperClassName={styles.skills_row_input}
                            onChange={(val: string) => updateSkills(val, indx)}
                        />
                        <TrashIcon
                            onClick={() => setMultipleChoiceExamSkills((prev) => prev.filter((_, i) => i !== indx))}
                        />
                    </div>
                )}
                <Button
                    text='+ Add another'
                    type='Outline-Primary'
                    className={styles.add_btn}
                    disabled={multipleChoiceExamSkills.length > 19}
                    onClick={() => setMultipleChoiceExamSkills(prev => [...prev, ''])}
                />
            </div>}
            {multipleChoiceExam && <div className={styles.translate}>
                <div className={styles.activate}>
                    <span className={styles.activate_title}>
                        Would you like the multiple choice exam to have additional languages?
                    </span>
                    <Toggle
                        toggled={translateExam}
                        setToggle={() => setTranslateExam(prev => !prev)}
                    />
                </div>
                {translateExam && <>
                    <span className={styles.translate_description}>
                        <b>English</b> is included by default. Select up to <b>2</b> additional languages.
                    </span>
                    <DropDown
                        idKey='id'
                        searchable
                        openListOnTop
                        titleKey='title'
                        selectedItem={null}
                        placeholder='exam languages'
                        dropDownList={examTranslateLanguagesList}
                        disabled={translateLanguages.length > 1}
                        setItem={(item: ListItem) => updateTranslateLanguages(item, 'Add')}
                    />
                    <div className={styles.translate_chips_box}>
                        <Chips title={defaultExamTranslateLanguage.title} />
                        {translateLanguages.map(item => <Chips
                            key={item.id}
                            title={item.title}
                            removeFunc={() => updateTranslateLanguages(item, 'Remove')}
                        />)}
                    </div>
                </>}
            </div>}
            <div className={styles.actions}>
                <Button
                    text='Back'
                    type='Outline-Primary'
                    className={styles.actions_btn}
                    onClick={() => setStep('RecruitingInterview')}
                />
                <Button
                    type='Primary'
                    text='Continue'
                    className={styles.actions_btn}
                    onClick={() => setStep(skipCodingExam ? 'ExamDeadline' : 'CodingExamDetail')}
                    disabled={multipleChoiceCodingExam && multipleChoiceCodingExamLanguages.every(i => !i)}
                />
            </div>
        </MotionWrapper>
    )
}
